interface ILeapHomeContainerProps {
  content: JSX.Element;
}

const EtsHomeContainer = ({ content }: ILeapHomeContainerProps) => (
  <div>{content}</div>
);

export default EtsHomeContainer;
